import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"

export default ({ data }) => (
    <Layout>
        <Helmet>
            <html lang="en" />
            <meta charSet="utf-8" />
            <meta name="description" content="About {data.site.siteMetadata.title}" />
            <title>About {data.site.siteMetadata.title}</title>
        </Helmet>
        <h1>About {data.site.siteMetadata.title}</h1>
        <p>
            We're the only site running on your computer dedicated to showing the best
            photos and videos of pandas eating lots of food.
        </p>
    </Layout>
)

export const query = graphql`
    query {
        site {
            siteMetadata {
                title
            }
        }
    }
`